import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import { TextField, Button, Typography, InputAdornment } from '@material-ui/core';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import Icon from 'sharedComponents/Icon';
import { validationSchema, initialValues } from 'forms/resetPasswordForm';

import useStyles from './useStyles';

const ResetPasswordForm = props => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { onSubmit } = props;
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const formik = useFormik({
    validationSchema,
    initialValues,
    onSubmit,
  });

  const { errors, values, handleChange, handleSubmit, isSubmitting, handleBlur, touched } = formik;

  const isAbleToSubmit = !isSubmitting && isEmpty(errors);
  const handleClickShowPassword = () => setPasswordVisible(!isPasswordVisible);

  return (
    <div className={classes.paper}>
      <Typography variant="h1">{t('components.ResetPasswordForm.header')}</Typography>
      <form noValidate onSubmit={handleSubmit}>
        <TextField
          error={touched.password && Boolean(errors.password)}
          helperText={touched.password && t(errors.password)}
          variant="outlined"
          name="password"
          type={isPasswordVisible ? 'text' : 'password'}
          id="password"
          placeholder={t('components.ResetPasswordForm.password')}
          autoComplete="new-password"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
          className={classes.field}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {isPasswordVisible ? (
                  <Icon name="visible" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                ) : (
                  <Icon name="visibleOff" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                )}
              </InputAdornment>
            ),
          }}
        />
        <TextField
          error={touched.passwordConfirmation && Boolean(errors.passwordConfirmation)}
          helperText={(touched.passwordConfirmation && t(errors.passwordConfirmation)) || ' '}
          variant="outlined"
          name="passwordConfirmation"
          placeholder={t('components.ResetPasswordForm.passwordConfirmation')}
          type={isPasswordVisible ? 'text' : 'password'}
          id="passwordConfirmation"
          autoComplete="new-password"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.passwordConfirmation}
          className={classes.field}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {isPasswordVisible ? (
                  <Icon name="visible" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                ) : (
                  <Icon name="visibleOff" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                )}
              </InputAdornment>
            ),
          }}
        />
        <Button className={classes.button} type="submit" disabled={!isAbleToSubmit}>
          {t('components.ResetPasswordForm.button')}
        </Button>
      </form>
    </div>
  );
};

ResetPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default ResetPasswordForm;



// WEBPACK FOOTER //
// ./src/sharedComponents/ResetPasswordForm/ResetPasswordForm.js